import { createPlausible } from 'v-plausible/vue';
import { defineAppPlugin } from '/app/utils/app';

const domain = typeof window !== 'undefined' ? window.location.hostname : 'bignerve.com';

const plausible = createPlausible({
    init: {
      domain,
      trackLocalhost: true,
    },
    settings: {
      enableAutoOutboundTracking: false,
      enableAutoPageviews: true,
    },
    partytown: false,
});

export default defineAppPlugin(({ app }) => {
    app.use(plausible);
});
